import { c as _c } from "react/compiler-runtime";
import Dishes from '@/components/modules/Dishes';
import { BBookableTypeEnum } from '@/types/backend';
import { Section } from '@winelidays/wld-tsx-2/modules';
import Description from './Description';
import MiscPracticals from './MiscPracticals';
import Prices from './Prices';
const havePricesTypes = [BBookableTypeEnum.Activity, BBookableTypeEnum.Meal];
const Practicals = t0 => {
    const $ = _c(26);
    const { descriptionTitle, description, mealContent, mealConfiguration, type, informations, reducedSectionWidth, className: t1, "data-nav-label": navLabel } = t0;
    const className = t1 === undefined ? "" : t1;
    let t2;
    if ($[0] !== type) {
        t2 = havePricesTypes.includes(type);
        $[0] = type;
        $[1] = t2;
    }
    else {
        t2 = $[1];
    }
    const hasPrices = t2;
    const sectionClassName = `pt-12 lg:pt-16 ${className}`;
    const pricesClassName = hasPrices ? `mb-12 lg:border-r lg:border-gray-200 lg:pr-4 lg:mb-6 ${reducedSectionWidth ? "lg:w-1/2" : "lg:w-1/3"}` : "";
    const miscClassName = `mb-12 lg:pl-16 xl:pl-20 first:pl-0 lg:mb-6 ${reducedSectionWidth ? "lg:w-1/2 first:!w-full" : "lg:w-2/3"}`;
    let t3;
    if ($[2] !== description || $[3] !== descriptionTitle || $[4] !== mealConfiguration) {
        t3 = <Description descriptionTitle={descriptionTitle} description={description} mealConfiguration={mealConfiguration} className="mb-6"/>;
        $[2] = description;
        $[3] = descriptionTitle;
        $[4] = mealConfiguration;
        $[5] = t3;
    }
    else {
        t3 = $[5];
    }
    let t4;
    if ($[6] !== mealConfiguration || $[7] !== mealContent) {
        t4 = mealContent && mealConfiguration && <Dishes mealContent={mealContent} mealConfiguration={mealConfiguration} className="mb-6"/>;
        $[6] = mealConfiguration;
        $[7] = mealContent;
        $[8] = t4;
    }
    else {
        t4 = $[8];
    }
    let t5;
    if ($[9] !== hasPrices || $[10] !== informations || $[11] !== miscClassName || $[12] !== pricesClassName || $[13] !== type) {
        t5 = informations && <>{hasPrices && <Prices type={type} prices={informations.prices} className={pricesClassName}/>}<MiscPracticals type={type} informations={informations} className={miscClassName}/></>;
        $[9] = hasPrices;
        $[10] = informations;
        $[11] = miscClassName;
        $[12] = pricesClassName;
        $[13] = type;
        $[14] = t5;
    }
    else {
        t5 = $[14];
    }
    let t6;
    if ($[15] !== t5) {
        t6 = <div className="practicals-rest flex flex-col w-full mt-6 lg:flex-row">{t5}</div>;
        $[15] = t5;
        $[16] = t6;
    }
    else {
        t6 = $[16];
    }
    let t7;
    if ($[17] !== t3 || $[18] !== t4 || $[19] !== t6) {
        t7 = <>{t3}{t4}{t6}</>;
        $[17] = t3;
        $[18] = t4;
        $[19] = t6;
        $[20] = t7;
    }
    else {
        t7 = $[20];
    }
    let t8;
    if ($[21] !== navLabel || $[22] !== reducedSectionWidth || $[23] !== sectionClassName || $[24] !== t7) {
        t8 = <Section id="practicals" className={sectionClassName} reducedSectionWidth={reducedSectionWidth} data-nav-label={navLabel}>{t7}</Section>;
        $[21] = navLabel;
        $[22] = reducedSectionWidth;
        $[23] = sectionClassName;
        $[24] = t7;
        $[25] = t8;
    }
    else {
        t8 = $[25];
    }
    return t8;
};
export default Practicals;
